import { useTranslation } from "react-i18next";

import useVehiclesMutations from "../../data/useVehiclesMutations";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { PartsStatusValues, IVehicle, PartsStatusDropdowns } from "../../models/Vehicle";

export default function AwaitingInventoryStatusDropdown({ vehicle, classes = "" }: { vehicle: IVehicle, classes?: string }) {
  const { t } = useTranslation("vehicles");
  const { patchVehicle } = useVehiclesMutations();
  const { saveHandlers } = useDefaultCRUDHandlers(t("Parts Status"));

  const partsStatus = [
    ...Object.values(PartsStatusDropdowns).filter((ct) => isNaN(Number(ct)))
  ];

  const handleStatusUpdate = (status: string) => {
    patchVehicle.mutate(
      //@ts-ignore
      { vehicleId: vehicle.id, patch: { engineExportStatus: PartsStatusValues[status] } },
      {
        onSuccess: () => saveHandlers.onSuccess(),
        onError: () => saveHandlers.onError(),
      }
    );
  }

  return (
    <div className="w-full h-full flex items-center" onClick={(e) => e.stopPropagation()}>

      <select aria-label={t("Parts Status")}
        onChange={(e) => handleStatusUpdate(e.target.value)}
        value={PartsStatusValues[vehicle.engineExportStatus]}
        className={`${classes} border border-gray-300 p-1`}>
        {partsStatus.map((status) => (
          <option
            className="sm:text-sm"
            key={status}
            value={String(status)}>
            {t(String(status))}
          </option>
        ))}
      </select>
    </div>
  )
}
